import { render, staticRenderFns } from "./PrivateChats.vue?vue&type=template&id=63035660&scoped=true&"
import script from "./PrivateChats.vue?vue&type=script&lang=js&"
export * from "./PrivateChats.vue?vue&type=script&lang=js&"
import style0 from "./PrivateChats.vue?vue&type=style&index=0&id=63035660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63035660",
  null
  
)

export default component.exports